/// <amd-module name="Wit/Deployment/Contracts" />
export interface IDeploymentType {
    name: string;
    pipelines: IPipeline[];
}
export interface IPipeline {
    id: number;
    name: string;
    status: string;
    date: Date;
    url: string;
    stages: IStage[];
}

export interface IStage {
    runId: number;
    name: string;
    status: string;
    sequenceNumber: number;
    url: string;
    date: Date;
}
